import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';

export interface EditScopeDialogData {
  scheduleTitle?: string;
}

@Component({
  selector: 'app-edit-scope-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatCardModule, MatDividerModule],
  template: `
    <div mat-dialog-title>
        <div>
            <h2 style="font-size: 1.35rem">
          Edit scope for this schedule
           </h2>
           <h3 class="mat-dialog-subtitle" style="margin:-20px 0 0 0; font-weight:500; color: rgba(0,0,0,0.7); font-size:0.95rem;">Choose how widely this change should apply.</h3>


        </div>

     </div>
        <mat-dialog-content>
      
      <div style="display:flex; flex-direction:column; gap:0; margin-top:8px;">
        <mat-card role="button" tabindex="0" (click)="onClose('pattern')" style="width:100%; background:transparent; box-shadow:none; border-radius:4px; padding:8px 0; cursor:pointer;">
          <div style="display:flex; align-items:center;">
            <div style="flex:1; padding:12px 16px;">
              <div style="font-weight:700; font-size:1rem; color: rgba(0,0,0,0.87);">Change recurring pattern</div>
              <div style="color: rgba(0,0,0,0.6); font-size:0.92rem; margin-top:6px;">Apply this change to every matching weekday between the schedule start and end dates. Example: editing a Tuesday slot updates every Tuesday between the schedule's start and end dates.</div>
            </div>
            <div style="width:48px; display:flex; align-items:center; justify-content:center;">
              <mat-icon style="color: rgba(0,0,0,0.54);">chevron_right</mat-icon>
            </div>
          </div>
        </mat-card>
        <mat-divider></mat-divider>
        <mat-card role="button" tabindex="0" (click)="onClose('calendar')" style="width:100%; background:transparent; box-shadow:none; border-radius:4px; padding:8px 0; cursor:pointer;">
          <div style="display:flex; align-items:center;">
            <div style="flex:1; padding:12px 16px;">
              <div style="font-weight:700; font-size:1rem; color: rgba(0,0,0,0.87);">Edit specific slots in calendar</div>
              <div style="color: rgba(0,0,0,0.6); font-size:0.92rem; margin-top:6px;">Open the calendar editor to change individual date/time slots without affecting other days.</div>
            </div>
            <div style="width:48px; display:flex; align-items:center; justify-content:center;">
              <mat-icon style="color: rgba(0,0,0,0.54);">chevron_right</mat-icon>
            </div>
          </div>
        </mat-card>
      </div>

    </mat-dialog-content>
    <mat-dialog-actions align="end" style="gap:8px; margin-top:12px;">
      <button mat-button (click)="onClose(null)">Cancel</button>
    </mat-dialog-actions>
  `
})
export class EditScopeDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<EditScopeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditScopeDialogData
  ) {}

  onClose(choice: 'pattern' | 'calendar' | null) {
    this.dialogRef.close(choice);
  }
}
